var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9025 0C17.1891 0 19.3898 2.30739 19.3898 5.73939V13.6611C19.3898 17.0824 17.1891 19.3898 13.9025 19.3898H5.49702C2.21044 19.3898 0 17.0824 0 13.6611V5.73939C0 2.30739 2.21044 0 5.49702 0H13.9025ZM13.7474 6.78644C13.4178 6.45681 12.8748 6.45681 12.5452 6.78644L8.54122 10.7904L6.84461 9.09383C6.51498 8.7642 5.97207 8.7642 5.64244 9.09383C5.31281 9.42346 5.31281 9.95668 5.64244 10.296L7.94983 12.5937C8.11464 12.7585 8.32793 12.8361 8.54122 12.8361C8.7642 12.8361 8.97749 12.7585 9.1423 12.5937L13.7474 7.98861C14.077 7.65898 14.077 7.12576 13.7474 6.78644Z",
    fill: "#499DD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.f18f4fb5e59f8451f5776f4883168505.svg";
export { ForwardRef as ReactComponent };